/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AppPatch = core.serialization.object({
    name: core.serialization.string().optional(),
    namespace: core.serialization.string().optional(),
    entity: core.serialization.string().optional(),
    entityPlural: core.serialization.string().optional(),
    icon: core.serialization.string().optional(),
    metadata: core.serialization.any().optional(),
    environmentFilters: core.serialization.any().optional(),
    blueprint: core.serialization.any().optional(),
    activatedAt: core.serialization.date().optional(),
});
